import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { MoreTestimonials } from './MoreTestimonials';
const plan = {
  name: '📘 THE AUTONOMOUS CHILD VISUAL SYSTEM™',
  ideal: 'Families with children ages 3-12 who want the routine to be visible instead of repeated',
  was: '$38',
  features: ['Complete 50-page eBook (A4, print-ready)', '6 routine volumes (Wake Up → Sleep)', 'Visual templates, icons & flashcards', 'Parent scripts & progress trackers', '5 Free Bonuses included', '30-Day Challenge protocol', '♾️ Lifetime access & future updates'],
  cta: 'Get the visual system now'
};
const trust = [{
  icon: LockIcon,
  label: '100% Secure Payment'
}, {
  icon: ZapIcon,
  label: 'Instant Access'
}, {
  icon: CreditCardIcon,
  label: 'Credit / Debit'
}, {
  icon: ShieldCheckIcon,
  label: '7-Day Guarantee'
}];
export function Pricing() {
  return <section id="pricing" aria-label="Pricing" className="bg-radial-glow w-full overflow-x-hidden" data-id="element-147" data-mp="3vzp6bk9ecea2">
      <div className="mx-auto w-full max-w-5xl px-5 py-12" style={{
      paddingTop: "15px",
      paddingBottom: "15px"
    }} data-id="element-148" data-mp="4svu7ld2euqr">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} id="offer-19" className="relative mx-auto flex w-full max-w-md scroll-mt-20 flex-col items-center rounded-3xl border border-blush/30 bg-white px-6 pb-7 pt-10 text-center shadow-[0_24px_60px_-28px_rgba(124,58,237,0.4)]" style={{
        paddingTop: "5px",
        paddingBottom: "15px",
        gap: "0px"
      }} data-id="element-149" data-mp="9rp6xbkj2hpv">
          <h3 className="font-display text-lg font-black text-plum" data-id="element-150" data-mp="3rxlkc1p3praj">{plan.name}</h3>
          <p className="mt-2 text-sm text-plum/60" data-id="element-151" data-mp="2uihbht6thzww">
            <span className="font-semibold text-plum/80" data-id="element-152" data-mp="2uhobrc6a0ao9">Ideal for:</span> {plan.ideal}
          </p>

          <div className="mt-6" data-id="element-153" data-mp="2zfzopvrvb1ap">
            <span className="text-base font-medium text-plum/40 line-through" style={{
            fontSize: "30px"
          }} data-id="element-154" data-mp="2zf7twn63h7lh">{plan.was}</span>
            <div className="flex justify-center" style={{
            paddingBottom: "26px",
            paddingTop: "20px"
          }} data-id="element-155" data-mp="2mijr76n4prx3">
              <div className="relative inline-block font-display leading-none text-blush-deep" data-id="element-156" data-mp="315cx5lardlcm">
                <span className="absolute right-full top-1/2 mr-1 -translate-y-1/2 font-black" style={{
                fontSize: "40px",
                fontFamily: "Montserrat, sans-serif"
              }} data-id="element-157" data-mp="2w8w90r3k76zj">
                  $
                </span>
                <span className="block" style={{
                fontSize: "72px",
                fontFamily: "Montserrat, sans-serif",
                fontWeight: "800"
              }} data-id="element-158" data-mp="23l0gzzoxq393">
                  19
                </span>
                <span className="absolute left-full top-1/2 ml-2 -translate-y-1/2 font-black" style={{
                fontSize: "24px",
                fontFamily: "Montserrat, sans-serif"
              }} data-id="element-159" data-mp="2djg5duwkuyew">
                  USD
                </span>
              </div>
            </div>
            <p className="mt-1 text-xs font-semibold text-blush" data-id="element-160" data-mp="8srz58huin9">
              One-time payment · No monthly subscription
            </p>
            <p className="mt-1 text-[11px] font-medium text-plum/50" style={{
            fontWeight: "600"
          }} data-id="element-161" data-mp="3nf39517myg05">
              Payment will be processed in your local currency.
            </p>
          </div>

          <ul className="mt-6 w-full flex-1 space-y-3 text-left" data-id="element-162" data-mp="j153ahh4ku9j">
            {plan.features.map(f => <li key={f} className="flex items-start gap-2.5 text-sm text-plum/80" data-id="element-163" data-mp="nzyeg38xw96j">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grape" strokeWidth={3} data-id="element-164" data-mp="o1srywhvsz0l" />
                {f}
              </li>)}
          </ul>

          <div className="mt-7 flex w-full justify-center" style={{
          paddingTop: "12px",
          paddingBottom: "5px",
          marginTop: "-10px",
          marginBottom: "-10px"
        }} data-id="element-165" data-mp="e9dcc5u24miv">
            <CTAButton size="md" data-id="element-166" data-mp="16q7ilioaeb0v">{plan.cta}</CTAButton>
          </div>

          <p className="mt-3 text-[11px] font-semibold text-plum/50" style={{
          marginTop: "15px",
          marginBottom: "15px"
        }} data-id="element-167" data-mp="16sk8qj477rp0">
            You save $176 (90% OFF)
          </p>
          

          <div className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-medium text-plum/55" style={{
          paddingBottom: "9px",
          marginTop: "-10px",
          marginBottom: "-10px"
        }} data-id="element-168" data-mp="3aaidbtktynvc">
            {trust.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-169" data-mp="1rauu7lqz57d">
                <Icon className="h-4 w-4 text-grape" data-id="element-170" data-mp="3synb8ket3em8" />
                {label}
              </span>)}
          </div>
        </motion.div>

        <MoreTestimonials data-id="element-171" data-mp="3o6net1xy33ue" />

        <div className="mx-auto mt-12 flex w-full max-w-2xl items-start gap-3 rounded-2xl border border-grape/20 bg-white/80 p-5 text-left" data-id="element-172" data-mp="3o5ub69ua8ugh">
          <ShieldCheckIcon className="mt-0.5 h-6 w-6 shrink-0 text-grape" data-id="element-173" data-mp="kk5al3r731cn" />
          <p className="text-[15px] leading-relaxed text-plum/75" data-id="element-174" data-mp="fsn6i6tvkkng">
            <span className="font-display font-bold text-plum" data-id="element-175" data-mp="fqalfkstlu66">
              🛡️ 7-Day Money-Back Guarantee.
            </span>{' '}
            If within the first 7 days you feel the system does not fit your family or does not
            make your routine simpler, request your refund and we return 100% of your money. We
            want you to try it with complete peace of mind, risk-free.
          </p>
        </div>
      </div>
    </section>;
}